import ParserModuleBase from "./ParserModuleBase";
export default class ParserModule extends ParserModuleBase {
    constructor(parser, baseDirectory) {
        super();
        this.parser = parser;
        this.baseDirectory = baseDirectory;
        this.__gl = parser.gl;
    }
    fetchGLTF(url) {
        return undefined;
    }
    /**
     * Load .gltf file
     * @return {Promise<GLTF>} [description]
     */
    loadAsGLTF(tf) {
        return undefined;
    }
    /**
     * Start loading texture resource.
     * @return {Promise<Texture2D>} [description]
     */
    fetchTextureResource(tf) {
        return undefined;
    }
    /**
     * Start loading texture resource.
     * @return {Promise<Texture2D>} [description]
     */
    loadTextureResources(tf) {
        return undefined;
    }
    /**
     * Load image as texture
     * @return {Promise<Texture2D>} [description]
     */
    convertTotexture(arg) {
        return undefined;
    }
    /**
     * Start loading buffer resource.
     * @return {Promise<ArrayBuffer>} [description]
     */
    loadBufferResource(tf) {
        return undefined;
    }
    loadBufferResources(tf) {
        return undefined;
    }
    loadBufferViews(args) {
        return undefined;
    }
    loadPrimitivesOfMesh(args) {
        return undefined;
    }
    loadPrimitive(args) {
        return undefined;
    }
    appendIndices(args) {
        return undefined;
    }
    addVertexAttributes(args) {
        return undefined;
    }
    complementVertexAttributes(args) {
        return undefined;
    }
    loadMaterials(args) {
        return undefined;
    }
    loadMaterial(args) {
        return undefined;
    }
    loadAnimations(args) {
        return undefined;
    }
    loadAnimation(args) {
        return undefined;
    }
}



// WEBPACK FOOTER //
// ./src/Parser/ParserModule.ts